import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table, Button, Badge } from "react-bootstrap";
import toast from "react-hot-toast";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import SimpleModal from "../../components/SimpleModal";
import { dataHse, arquivoDocumento } from "./statusHse";

const MOTIVO_MINIMO = 5;

export const FilaAprovacao = () => {
  const [fila, setFila] = useState([]);
  const [busca, setBusca] = useState("");
  const [tipo, setTipo] = useState("");
  const [reprovando, setReprovando] = useState(null);
  const [motivo, setMotivo] = useState("");

  const getFila = async () => {
    try {
      const res = await blogFetch.get("/sga/document/queue");
      setFila(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getFila();
  }, []);

  const termo = busca.toLowerCase();
  const filtrados = fila
    .filter(
      (d) =>
        (!termo ||
          d.colaborador?.toLowerCase().includes(termo) ||
          d.cpf?.includes(busca) ||
          d.empresa?.toLowerCase().includes(termo)) &&
        (!tipo || d.tipo === tipo)
    )
    .sort((a, b) => a.dataEnvio - b.dataEnvio);

  const concluir = async (doc, acao, body) => {
    try {
      await blogFetch.put(`/sga/document/${doc.id}/${acao}`, body);
      setFila((atual) => atual.filter((d) => d.id !== doc.id));
      toast.success(`${doc.tipo} de ${doc.colaborador} ${acao === "approve" ? "aprovado" : "reprovado"}.`);
    } catch (err) {
      toast.error("Erro ao registrar a análise.");
    }
  };

  const reprovar = async () => {
    if (motivo.trim().length < MOTIVO_MINIMO) {
      toast.error(`Informe o motivo (mínimo ${MOTIVO_MINIMO} caracteres).`);
      return;
    }
    await concluir(reprovando, "reject", { motivo: motivo.trim() });
    setReprovando(null);
    setMotivo("");
  };

  const abrirAnexo = async (doc) => {
    try {
      await arquivoDocumento(doc);
    } catch (err) {
      toast.error("Não foi possível abrir o anexo.");
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">
          Fila de Aprovação <Badge bg="primary">{fila.length}</Badge>
        </h3>

        <Row className="g-3 mb-4">
          <Col md={4}>
            <Form.Control
              type="search"
              placeholder="Buscar colaborador, CPF ou empresa"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="">Todos os documentos</option>
              {[...new Set(fila.map((d) => d.tipo))].map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <div className="table-responsive" style={{ maxHeight: "600px" }}>
          <Table striped hover bordered className="align-middle text-center" style={{ minWidth: "1000px" }}>
            <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
              <tr>
                {["Enviado", "Colaborador", "CPF", "Empresa", "Documento", "Versão", "Emissão", "Validade", "Anexo", "Ações"].map(
                  (c) => <th key={c} className="text-nowrap">{c}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {filtrados.length ? (
                filtrados.map((d) => (
                  <tr key={d.id}>
                    <td>{dataHse(d.dataEnvio)}</td>
                    <td>{d.colaborador}</td>
                    <td className="text-nowrap">{d.cpf}</td>
                    <td>{d.empresa}</td>
                    <td className="fw-bold">{d.tipo}</td>
                    <td>v{d.versao}</td>
                    <td>{dataHse(d.dataEmissao)}</td>
                    <td>{dataHse(d.dataValidade)}</td>
                    <td>
                      <Button variant="link" size="sm" onClick={() => abrirAnexo(d)}>
                        {d.arquivo || "-"}
                      </Button>
                    </td>
                    <td className="text-nowrap">
                      <Button variant="success" size="sm" className="me-2" onClick={() => concluir(d, "approve")}>
                        Aprovar
                      </Button>
                      <Button variant="danger" size="sm" onClick={() => setReprovando(d)}>
                        Reprovar
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-muted fst-italic">Nenhum documento aguardando análise.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <SimpleModal
          isShow={!!reprovando}
          setShowModal={() => {
            setReprovando(null);
            setMotivo("");
          }}
          title={`Reprovar ${reprovando?.tipo || ""} - ${reprovando?.colaborador || ""}`}
          body={
            <Form.Control
              as="textarea"
              rows={3}
              placeholder={`Motivo da reprovação (mínimo ${MOTIVO_MINIMO} caracteres)`}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          }
          btnTextAction="REPROVAR"
          btnColorAction="danger"
          onClickAction={reprovar}
        />
      </Container>
    </>
  );
};
